import axios from '../services/axiosConfig';

const API_URL = process.env.REACT_APP_API_URL;

export const getRoles = async () => {
  try {
    const response = await axios.get(`${API_URL}/roles`);
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};

export const getRoleById = async (roleId) => {
  try {
    const response = await axios.get(`${API_URL}/roles/${roleId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching role with ID ${roleId}:`, error);
    throw error;
  }
};

export const createRole = async (roleData) => {
  try {
    const response = await axios.post(`${API_URL}/roles`, roleData);
    return response.data;
  } catch (error) {
    console.error('Error creating role:', error);
    throw error;
  }
};

export const updateRole = async (roleId, roleData) => {
  try {
    const response = await axios.put(`${API_URL}/roles/${roleId}`, roleData);
    return response.data;
  } catch (error) {
    console.error(`Error updating role with ID ${roleId}:`, error);
    throw error;
  }
};

export const deleteRole = async (roleId) => {
  try {
    const response = await axios.delete(`${API_URL}/roles/${roleId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting role with ID ${roleId}:`, error);
    throw error;
  }
};

export const assignUserToRole = async (userId, roleId) => {
  try {
    const response = await axios.post(`${API_URL}/roles/${roleId}/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`Error assigning user ${userId} to role ${roleId}:`, error);
    throw error;
  }
};

export const removeUserFromRole = async (userId, roleId) => {
  try {
    const response = await axios.delete(`${API_URL}/roles/${roleId}/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`Error removing user ${userId} from role ${roleId}:`, error);
    throw error;
  }
};

export const getUserRoles = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/users/${userId}/roles`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching roles for user ${userId}:`, error);
    throw error;
  }
};

export const configureExternalRoles = async (externalRoleMappings) => {
  try {
    const response = await axios.post(`${API_URL}/roles/external-mappings`, externalRoleMappings);
    return response.data;
  } catch (error) {
    console.error('Error configuring external roles:', error);
    throw error;
  }
};